import React, { useState, useContext, useEffect } from "react";
import styles from "../Firing/Firing.module.css";
import { store } from "../../Components/HOC/State";
import UnitListItem from "../MilUnitList/UnitListItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import { axiosInstance } from "../../Helpers/axiosInstance";
import "react-datepicker/dist/react-datepicker.css";
import baseStyle from "../BaseList/BaseList.module.css";
import DatePicker from "react-datepicker";
import AccidentUnitModal from "../../Modals/Accident/AccidentUnitModal";
// import AccidentInfo from "./AccidentInfo";

const AccidentUnit = () => {
  const [selectedName, setSelectedName] = useState("Զորամաս");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUnit, setCurrentUnit] = useState();
  const { fetchUnits, unitList} = useContext(store);
  const [corpuses, setCorpuses] = useState([]);
  const [search, setSearch] = useState("");
  const [added, setAdded] = useState(false);
  const [accidentInfo, setAccidentInfo] = useState([])
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange

  useEffect(() => {
    fetchUnits();
  }, []);

  useEffect(() => {
    (async () => {
      const res = await axiosInstance.get("admin/corpuses");
      if (res.data.status) {
        setCorpuses(res.data.data);
      }
    })();
  }, []);

  useEffect(() => {
    if (added) {
      setTimeout(() => setAdded(false), 100);
    }
  }, [added]);

  return (
    <div className={styles["main-div"]}>
      <div className={styles["body-div"]}>
          <input
            type="text"
            placeholder="Որոնել"
            className={baseStyle["search-input"]}
            style={{ marginTop: "10px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        <div className={styles["header-row"]}>
          <h2>{selectedName}</h2>
            <div>
              <FontAwesomeIcon
                icon={faPlus}
                className={styles["adding"]}
                title="Ավելացնել տվյալներ"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsModalOpen(true);
                  setCurrentUnit(null);
                }}
              />
            </div>
        </div>

        <div className={styles["units-bases-div"]}>
            <div className={baseStyle["unit-list-container"]}>
              {!!unitList.filter(
                (el) =>
                  (el.unit_number.includes(search) ||
                    el.unit_close_number.includes(search)) &&
                  el.unit_corpus === "",
              ).length && (
                <div>
                  <h4 className={styles["corpus-header"]}>ՀԲԿ</h4>
                  {unitList
                    .filter(
                      (el) =>
                        (el.unit_number.includes(search) ||
                          el.unit_close_number.includes(search)) &&
                        el.unit_corpus === "",
                    )
                    .map((item, index) => (
                      <UnitListItem
                        key={index}
                        item={item}
                        index={index}
                        added={added}
                        unitList={unitList}
                        closeModal={() => setIsModalOpen(false)}
                        setAdded={setAdded}
                        currentUnit={currentUnit}
                        onClick={() => {
                            if(currentUnit?._id === item._id){
                                setCurrentUnit(null)
                            }else{
                                setCurrentUnit(item);
                            }
                        }}
                      />
                    ))}
                </div>
              )}
              {corpuses.map((corpus, index) =>
                unitList.filter(
                  (el) =>
                    (el.unit_number.includes(search) ||
                      el.unit_close_number.includes(search)) &&
                    el.unit_corpus === corpus._id,
                ).length ? (
                  <div className={baseStyle["unit-list-container"]} key={index}>
                    <div className={`${styles["corpus-header"]} relative`}>
                      {/* <div className="w-fit flex justify-end absolute top-0 right-4">
                          <DatePicker
                            selectsRange
                            startDate={startDate}
                            endDate={endDate}
                            onChange={(update) => {
                              setDateRange(update);
                            }}
                            placeholderText="Ժամանակահատված"
                            className="border-b border-b-gray-400 rounded-lg outline-none mr-4 text-center"
                            dateFormat="dd.MM.yyyy"
                          />
                          <img
                            src="/excel.png"
                            alt="Excel"
                            className={`${styles["excel-icon"]}`}
                            onClick={() => {
                            }}
                          />

                      </div> */}
                      <p>{corpus.corpus_number} {corpus.corpus_name}</p>
                    </div>
                    {unitList
                      .filter(
                        (el) =>
                          (el.unit_number.includes(search) ||
                            el.unit_close_number.includes(search)) &&
                          el.unit_corpus === corpus._id,
                      )
                      .map((item, index) => (
                     <UnitListItem
                        key={index}
                        item={item}
                        index={index}
                        added={added}
                        unitList={unitList}
                        closeModal={() => setIsModalOpen(false)}
                        setAdded={setAdded}
                        currentUnit={currentUnit}
                        onClick={() => {
                            if(currentUnit?._id === item._id){
                                setCurrentUnit(null)
                            }else{
                                setCurrentUnit(item);
                            }
                        }}
                      />
                    ))}
                  </div>
                ) : (
                  ""
                ),
              )}
            </div>
         
          {isModalOpen ? (
            <AccidentUnitModal
              unitList={unitList}
              closeModal={() => {
                setIsModalOpen(false);
              }}
              currentUnit={currentUnit}
              setAdded={setAdded}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default AccidentUnit;
